import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { PlanungApiRoutingModule } from "./planung-api-routing.module";
import { FormControlsModule } from "../common-components/form-controls/form-controls.module";
import { PlanungApiProcessingOrderModule } from "./processing-order/planung-processing-order.module";
import { PlanungApiTaskDetailModule } from "./planung-api-tasks/task-detail/task-detail.module";
import { FormularEditorModule } from "./planung-api-tasks/formular/edit/task-formular-edit.module";
import { CommonComponentsModule } from "../common-components";
import { MatTableModule } from "@angular/material/table";
import { MatSortModule } from "@angular/material/sort";
import { MatSelectModule } from '@angular/material/select';
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        PlanungApiRoutingModule,
        FormControlsModule,
        PlanungApiProcessingOrderModule,
        PlanungApiTaskDetailModule,
        FormularEditorModule,
        CommonComponentsModule,
        MatTableModule,
        MatSortModule,
        MatSelectModule
    ],
    declarations: [],
    exports: [CommonComponentsModule],
})
export class PlanungApiModule { }
